import { render, staticRenderFns } from "./InvoicesRecNew.vue?vue&type=template&id=9c538a5e&scoped=true"
import script from "./InvoicesRecNew.vue?vue&type=script&lang=js"
export * from "./InvoicesRecNew.vue?vue&type=script&lang=js"
import style0 from "./InvoicesRecNew.vue?vue&type=style&index=0&id=9c538a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c538a5e",
  null
  
)

export default component.exports